<template>
  <div :class="'item ' + active">
    <div class="slider-wrapper">
      <div :class="'slider-photo-' + crowdOrRais">
        <router-link :to="{ name: 'show_crowdfunding', params: { id: project.id, title: project.title.replace(/ /g, '-') } }">
          <img v-if="project.photo.url" :src="$server_url + project.photo.url">
          <img v-else src="~assets/img/projectPlaceholder.png">
        </router-link>
        <div class="slider-text-bg">
          <div :class="'slider-text-' + crowdOrRais">
            <router-link :to="{ name: 'crowdfunding', query: { category: project.category.name } }" class="category">{{ project.category.name }}</router-link>
            <br/>
            <router-link :to="{ name: 'show_crowdfunding', params: { id: project.id, title: project.title.replace(/ /g, '-') } }" class="title">{{ project.title }}</router-link>
            <br/>
            <router-link :to="{ name: 'show_profile', params: { id: project.user.id } }" class="author">{{ project.user.full_name }}</router-link>
            <br/>
            <p class="short-desc">{{ project.description }}</p>
          </div>
        </div>
      </div>
      <div :class="'slider-right-' + crowdOrRais"><strong>CROWDFUNDING</strong>
        <p class="allready-raised">${{ project.collected | price }}</p>
        <div class="bar-goal">
          <div class="bar-raised" :style="{ width: ((project.collected / project.to_collect) * 100) + '%' }"></div>
        </div>
        <div class="goal-percent">{{ completion }}%</div>
        <div class="days-left">
          <div v-if="project.deadline && project.status === 'published'">{{ project.deadline | daysLeft }} {{ $t('project.daysLeft') }}</div>
          <div v-if="project.deadline && project.status === 'successful'">{{ $t('project.ended') }}</div>
          <div v-if="!project.deadline">{{ project.duration + ' ' + $t('project.daysLeft')}}</div>
        </div>
        <router-link :to="{ name: 'show_crowdfunding', params: { id: project.id, title: project.title.replace(/ /g, '-') } }" role="button" class="btn btn-default btn-lg button-wide">CONTRIBUTE NOW</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['project', 'active'],
  computed: {
    crowdOrRais() {
      return this.project.crowdfunding ? 'crowd' : 'rais';
    },
    completion() {
      return Math.round((this.project.collected / this.project.to_collect) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Slide.vue?baa1e404